import { render } from "./VoyagesView.vue?vue&type=template&id=1ecba300&scoped=true"
import script from "./VoyagesView.vue?vue&type=script&lang=js"
export * from "./VoyagesView.vue?vue&type=script&lang=js"

import "./VoyagesView.vue?vue&type=style&index=0&id=1ecba300&scoped=true&lang=css"
import "./VoyagesView.vue?vue&type=style&index=1&id=1ecba300&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecba300"]])

export default __exports__